import React from "react";
import { motion } from "framer-motion";
import styles from "./ItemWrap.module.css";

interface ItemWrapProps {
  children: React.ReactNode;
}

export const ItemWrap: React.FC<ItemWrapProps> = ({ children }) => (
  <motion.div
    initial={{ height: 0, opacity: 0 }}
    animate={{ height: "auto", opacity: 1 }}
    exit={{ height: 0, opacity: 0 }}
    transition={{ type: "spring", stiffness: 220, damping: 26 }}
    className={styles.itemWrap}
  >
    {children}
  </motion.div>
);